<template slot="trips" slot-scope="props">
  <tr
    style="cursor: pointer;"
    :class="{ 'blue lighten-5': updated, 'green lighten-5': created, 'grey lighten-4': closed, 'red lighten-5': credit }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="detailDialog = true"
  >
    <td @click.stop>
      <v-checkbox v-model="selected" :color="$store.state.global.pages.docket.color" hide-details></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, trip)) || "-" }}</span>
      <span v-if="header.type == 'time'">{{ getUTCTime(getObjectPath(header.value, trip)) || "-" }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ !!getObjectPathRootExists(header.value, trip) ? displayDecimal(getObjectPath(header.value, trip),header.decimals) : "-" || "-" }}</span>
      <span
        v-if="header.type == 'curr' "
      >{{ !!getObjectPath(header.value, trip) ? `$${displayDecimal(getObjectPath(header.value, trip),header.decimals)}` : "-" || "" }}</span>
      <span
        v-if="header.type == 'text'"
      >{{header.value == 'rctiId' ? getRctiId() : getObjectPath(header.value, trip) || "-"}}</span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <v-tooltip left v-for="(field, i) in operations" :key="i">
          <v-btn
            icon
            flat
            color="grey"
            slot="activator"
            :disabled="closed"
            @click="confirmUpdateTripField(field)"
          >
            <v-icon
              color="green lighten-2"
              v-if="trip[field.field] == 'CONFIRMED' || trip[field.field] == '1'"
            >{{field.iconOn}}</v-icon>
            <v-icon color="orange lighten-2" v-if="trip[field.field] == 'REVIEW'">{{field.iconOn}}</v-icon>
            <v-icon color="red lighten-2" v-if="trip[field.field] == 'REQUIRED'">{{field.iconOn}}</v-icon>
            <v-icon
              color="grey"
              v-if="trip[field.field] == 'NOT SET' || trip[field.field] == '0' || trip[field.field] == null"
            >{{field.iconOff}}</v-icon>
          </v-btn>
          <span>
            {{`${field.label} data is ${trip[field.field]} for this trip`}}
            <br />
            {{trip[field.notesField] ? `Notes: ${trip[field.notesField]}` : ``}}
          </span>
        </v-tooltip>

        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile
              title="Docket Summary"
              :color="$store.state.global.pages.docket.color"
              :icon="$store.state.global.pages.docket.icon"
              :onClick="viewDocketDialog"
            ></basic-list-tile>

            <template v-if="!closed">
              <basic-list-tile
                v-if="!credit && !addition"
                title="Add Trip"
                :color="$store.state.global.pages.docket.color"
                icon="add"
                :onClick="showAddDocketFromDocket"
              ></basic-list-tile>
              <basic-list-tile title="Edit Trip" icon="edit" :onClick="editTrip"></basic-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile
                v-for="(field, i) in operations"
                :key="i"
                @click="confirmUpdateTripField(field)"
                ripple
              >
                <v-list-tile-action>
                  <v-icon
                    v-if="trip[field.field]== 'CONFIRMED' || trip[field.field]== '1'"
                    color="green lighten-2"
                  >{{field.iconOn}}</v-icon>
                  <v-icon
                    v-if="trip[field.field]== 'REVIEW'"
                    color="orange lighten-2"
                  >{{field.iconOff}}</v-icon>
                  <v-icon
                    v-if="trip[field.field]== 'REQUIRED'"
                    color="red lighten-2"
                  >{{field.iconOff}}</v-icon>
                  <v-icon
                    v-if="trip[field.field]== 'NOT SET' || trip[field.field] == '0' || trip[field.field]== 'UNCONFIRMED'"
                    color="grey lighten-2"
                  >{{field.iconOff}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>{{`Update ${field.label} Data`}}</v-list-tile-title>
              </v-list-tile>
              <v-divider inset></v-divider>
              <basic-list-tile
                color="red lighten-3"
                title="Delete"
                icon="delete"
                :onClick="deleteTrip"
              ></basic-list-tile>
            </template>
            <basic-list-tile
              title="Docket Credit"
              :color="$store.state.global.pages.docket.color"
              icon="remove_circle"
              :onClick="createCredit"
              v-if="!credit && userAuthClass"
            ></basic-list-tile>
            <basic-list-tile
              title="Docket Addition"
              :color="$store.state.global.pages.docket.color"
              icon="add_circle"
              :onClick="createAddition"
              v-if="!credit && !addition && userAuthClass"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->
    <!--  TRIP FIELD CONFIRMATION DIALOG  -->
    <v-dialog
      lazy
      v-model="actionConfirmationDialog"
      max-width="700px"
      @keydown.esc="actionConfirmationDialog = false"
    >
      <single-actions
        :trip="trip"
        :fieldData="fieldData"
        :notes="currentNotes"
        :status="currentStatus"
        @close="actionConfirmationDialog = false"
        @actionComplete="actionComplete()"
      ></single-actions>
    </v-dialog>
    <!-- Docket display dialog -->
    <v-dialog lazy max-width="700px" v-model="docketDialog" @keydown.esc="docketDialog = false">
      <docket-display
        :trip="trip"
        :docket="trip.docket"
        @showTripFromDocket="showTripFromDocket"
        @showAddTrip="showAddDocketFromDocket"
        @showEditDocket="showEditDocketFromDocket"
      ></docket-display>
    </v-dialog>
    <!-- Edit Docket dialog -->
    <v-dialog
      lazy
      max-width="700px"
      v-model="editDocketDialog"
      @keydown.esc="editDocketDialog = false"
    >
      <edit-docket :docket="trip.docket" @close="editDocketDialog = false"></edit-docket>
    </v-dialog>
    <!-- Trip edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-trip @close="editDialog = false" :trip="trip"></edit-trip>
    </v-dialog>
    <!-- Trip add dialog -->
    <v-dialog lazy v-model="addTripDialog" max-width="700px" @keydown.esc="addTripDialog = false">
      <add-trip @close="addTripDialog = false" :docket="trip.docket"></add-trip>
    </v-dialog>
    <!-- Trip Detail dialog -->
    <v-dialog lazy v-model="detailDialog" max-width="700px" @keydown.esc="detailDialog = false">
      <trip-detail
        :trip="trip"
        @seeDocketDetails="detailDialog = false; docketDialog = true"
        @seeEditTrip="detailDialog = false; editDialog = true"
      ></trip-detail>
    </v-dialog>
    <!-- Trip Delete dialog -->
    <v-dialog lazy v-model="deleteDialog" max-width="700px" @keydown.esc="deleteDialog = false">
      <trip-delete-prompt :trip="trip" @close="deleteDialog = false"></trip-delete-prompt>
    </v-dialog>
  </tr>
</template>

<script>
import EditDocket from '@/components/dockets/editDocket'
import EditTrip from '@/components/trips/editTrip'
import AddTrip from '@/components/trips/addTrip'
import FormatDates from '@/services/mixins/formatDates'
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'
import DocketDisplay from '@/components/dockets/docket'
import SingleActions from '@/components/trips/actions/singleActions'
import TripDetail from '@/components/trips/actions/tripDetail'
import TripDeletePrompt from '@/components/trips/actions/tripDeletePrompt'

import CreatedUpdatedRows from '@/services/mixins/createdUpdatedRows'
import RowDisplayMethods from '@/services/mixins/rowDisplayMethods'
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  data() {
    return {
      prefix: 'trip',
      editDialog: false,
      editDocketDialog: false,
      detailDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      docketDialog: false,
      addTripDialog: false,
      actionsMenu: false,
      currentNotes: '',
      currentStatus: '',
      fieldData: {},
      operations: [
        {
          field: 'GPSConfirmed',
          label: 'GPS',
          notesField: 'GPSNotes',
          iconOn: 'gps_fixed',
          iconOff: 'gps_not_fixed'
        },
        {
          field: 'massDeclarationConfirmed',
          label: 'Mass Declaration',
          notesField: 'massDeclarationNotes',
          iconOn: 'shopping_basket',
          iconOff: 'shopping_basket'
        },
        {
          field: 'tippingDocketConfirmed',
          label: 'Tipping Docket',
          notesField: 'tippingDocketNotes',
          iconOn: 'delete_sweep',
          iconOff: 'delete_sweep'
        }
      ]
    }
  },
  methods: {
    showAddDocketFromDocket() {
      this.docketDialog = false
      this.addTripDialog = true
    },
    showEditDocketFromDocket() {
      this.docketDialog = false
      this.editDocketDialog = true
    },
    showTripFromDocket(tripId) {
      if (tripId == this.trip.id) {
        this.docketDialog = false
        this.detailDialog = true
      } else {
        this.docketDialog = false
        this.$emit('showTripFromDocket', tripId)
      }
    },
    actionComplete() {
      this.fieldData = {}
      this.actionConfirmationDialog = false
    },
    deleteTrip() {
      this.deleteDialog = true
    },
    createCredit() {
      this.createAdjustment('CREDIT')
    },
    createAddition() {
      this.createAdjustment('ADDITION')
    },
    createAdjustment(type) {
      DocketService.getTripsByDocket(this.trip.docketId)
        .then(result => {
          var trips = result.data.result.map(trip => {
            if (!!trip.start && !!trip.end) {
              trip.start = this.getUTCTime(trip.start)
              trip.end = this.getUTCTime(trip.end)
            }
            return trip
          })
          this.$store.commit('dockets/setState', {
            prop: 'adjustmentData',
            value: { docket: this.trip.docket, trips: trips, type: type }
          })
        })
        .catch(err => {
          console.log(err)
          this.snack({ text: err.response.data.message, color: 'red' })
        })
    },

    editTrip() {
      this.editDialog = true
    },
    viewDocketDialog() {
      this.docketDialog = true
    },
    confirmUpdateTripField(payload) {
      //payload.value =value
      this.fieldData = payload
      this.currentStatus = this.trip[payload.field]
      this.currentNotes = this.trip[payload.notesField]
      this.actionConfirmationDialog = true
    },
    getRctiId() {
      //console.log('getting RCTI ID');

      if (!!this.trip.rcti) {
        //console.log('Got the RCTI!!');

        return !!this.trip.rcti.externalRef
          ? this.trip.rcti.externalRef
          : this.trip.rctiId
      } else {
        return this.trip.rctiId
      }
    }
  },
  computed: {
    //showCredit: Store.getSet({store: 'trips', prop: 'showCredit'}),
    closed() {
      if (!!this.trip.rctiId || !!this.trip.billId) return true
      return false
    },
    credit() {
      if (this.trip.docket.type == 'CREDIT') return true
      return false
    },
    addition() {
      if (this.trip.docket.type == 'ADDITION') return true
      return false
    },
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', { value: val, object: this.trip })
      }
    }
  },
  mounted() {
    if (this.trip.new) {
      this.newTrip = true
      setTimeout(() => {
        this.newTrip = false
      }, 10000)
    }
  },
  props: {
    trip: Object,
    headers: Array,
    value: Boolean
  },
  components: {
    EditTrip,
    AddTrip,
    DocketDisplay,
    EditDocket,
    SingleActions,
    TripDetail,
    TripDeletePrompt
  }
}
</script>

<style scoped>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}
.new {
  border-left: solid 4px;
  border-color: var(--v-success-base) !important;
}
</style>
